import PageHeader from "../../components/layout/PageHeader.jsx";
import Tooltip from "../../components/common/Tooltip";
import { useHistory } from "react-router-dom";
import SuperAdmin from '../../hooks/SuperAdmin';
import { client } from "../../hooks/Client";
import uuid from "react-uuid";
import { useFirestoreNoCompagnyGeneralOrderBy } from "../../firebase/useFirestore";
import { db, timestamp } from "../../firebase/config";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import deleteIcon from "../../images/icons/delete-icon.png";

/**
 * @deprecated Use LiveReports2 instead
 */
const LivereportTemplates = () => {

    // History
    const history = useHistory()
    const superAdmin = SuperAdmin();

    // Firestore
     const reports = useFirestoreNoCompagnyGeneralOrderBy('LiveReports', 'Template', true, 'Position', 'asc') 

    // Add template handler
    const addTemplateHandler = async () => {

        const id = uuid();

        await db.collection('LiveReports')
        .add({
            Title: 'Nieuwe live rapportage template',
            Timestamp: timestamp,
            Position: reports.length + 1,
            ID: id,
            Start: null,
            End: null,
            Template: true,
            CompagnyID: client,
            Compagny: client
        })

        history.push(`/${client}/livereporttemplatebuilder/${id}`);
    }

    // Delete handler
    const deleteTemplateHandler = async (e) => {
        const docId = e.target.dataset.docid;

        await db.collection('LiveReports').doc(docId).delete();
        // await db.collection('ReportLayouts').doc(docId).delete();
    }

    // Start from scratch handler
    const startFromScratchHandler = async () => {
        const id = uuid();

        await db.collection('LiveReports')
        .add({
            Title: 'Nieuwe live rapportage',
            Timestamp: timestamp,
            Position: reports.length + 1,
            ID: id,
            Start: null,
            End: null,
            Template: false,
            CompagnyID: client,
            Compagny: client,
            Version: 2
        })

        history.push(`/${client}/livereporttemplatebuilder/${id}`);
    }

  return (
    <div className="main">
        <div className="main-container">
            <PageHeader 
                heading={'Live rapportage templates'}
                description={`Hier kun je live rapportage templates bekijken en selecteren.`}
                AI={false}
            />

             <div className="dashboard-container">  
                <div
                    className="dashboard-cards"
                >

                    {/* Add template as superadmin */}
                    {superAdmin.admin === true &&
                        <div
                        className="dashboard-card add-card"
                        onClick={addTemplateHandler}
                        aria-label="Dashboard toevoegen"
                        >
                            <span className="add-icon">+</span>
                            <span>Template toevoegen</span>
                        </div>
                    }

                    {/* Start from scratch */}
                    <div
                        className="dashboard-card add-card"
                        onClick={startFromScratchHandler}
                        aria-label="Dashboard toevoegen"
                        >
                            <span className="add-icon">+</span>
                            <span>Begin vanaf nul</span>
                        </div>

                    {reports &&
                    reports.map((item, index) => (
                            <div
                            key={item.ID}
                            onClick={(e) => {
                                            e.stopPropagation();
                                            history.push(`/${client}/livereportopen/${item.ID}/open`);
                                        }}
                             className="dashboard-card"
                             id='live-report-template-card'
                            >
                                
                                <div className="card-left">
                                   <h1>{item.Title}</h1>
                                </div>  
                                {/* <div className="card-use-template-container">
                                    <p>Deze template gebruiken</p>
                                </div> */}
                                {superAdmin.admin &&
                                  <div className="card-actions">
                                    <Tooltip
                                    content={"Dashboard aanpassen"}
                                    width="100%"
                                    top="-60px"
                                    >
                                    <EditOutlinedIcon
                                        className="card-icon"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            history.push(`/${client}/livereports2/${item.ID}`);
                                        }}
                                    />
                                    </Tooltip>
    
                                    <Tooltip
                                    content={"Dashboard verwijderen"}
                                    width="100%"
                                    top="-60px"
                                    >
                                    <img
                                        className="card-icon"
                                        data-docid={item.docid}
                                        data-deletename={item.Title}
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        deleteTemplateHandler(e);
                                        }}
                                        src={deleteIcon}
                                        alt="Verwijderen"
                                    />
                                    </Tooltip>
                                    </div> 
                                }    
                            </div>
                        ))}
                    </div>
                </div>
        </div>
    </div>
  )
}

export default LivereportTemplates